var SENTRY_RELEASE;SENTRY_RELEASE={name: "Digima", version: "1.3.0"};